<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8PJM1Q/tc-custom/9781439678176.jpg?1705539782489" alt="This image is the cover for the book LGBTQ+ Trailblazers of San Francisco"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">LGBTQ+ Trailblazers of San Francisco
      </h1>
      <p class="bookDescription body article font2">
        <p>Famous and forgotten, they're all our fabulous ancestors. <br/> From Charles Warren Stoddard, the first openly gay San Franciscan, to Felicia "Flames" Elizondo, the exuberant transgender rights advocate, the LGBT community is integrally woven into the fabric of the city's history. Household names like Queen Califia, Charley Parkhurst, Elsa Gidlow, Jose Sarria and Harvey Milk are celebrated worldwide, while Bert LaRose, Mabel Edison and Clarence Lockett are now largely forgotten. Whether '49ers, bohemians, beatniks, boomers, hippies, clones or conformists, their fascinating stories contributed to the development of a vibrant community, many simply by being themselves. <br/> Join Dr. William Lipsky as he recounts their struggles and achievements in the City by the Bay.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dr. William Lipsky
      </h2>
      
      <p class="authorDescription body article">Bill Lipsky received his doctorate in history from Carnegie Mellon University. He has been a Visiting Assistant Professor of Education at Pepperdine University, Los Angeles, and a curriculum specialist with the Graduate School of Education, UCLA. He is the author of Gay and Lesbian San Francisco , a docent at the GLBT Museum and a member of the board of directors of the Rainbow Honor Walk. His monthly column, "Faces from Our LGBT Past," appears in the San Francisco Bay Times .</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?12d9d03f